<template>
  <!-- <div>{{record.userid.name}} - {{record.userid.company.name}}</div> -->
  <div>{{record.userid.name}}</div>
</template>

<script>
export default {
  props: {
    record: Object, // 当前行的数据
    value: null, // 当前这个字段的值，如果这个字段是虚构的，则必定是空
    model: Object, // 当前model对象
    field: Object // 当前field对象
  },
}
</script>

<style>

</style>
